/**
 * Сохранение файла на устройство пользователя.
 *
 * Выгрузка прогресса — это файл, а не экран: её забирают с собой (ТЗ US-08).
 * Браузерная механика живёт здесь, чтобы продуктовая функция о ней не знала.
 */

/** Порт сохранения файла. */
export interface JsonSaver {
  /** Отдаёт данные пользователю файлом с указанным именем. */
  save(filename: string, data: unknown): void;
}

/** Создаёт сохранение через ссылку с объектным URL. */
export function createJsonSaver(): JsonSaver {
  return {
    save(filename: string, data: unknown): void {
      const blob = new Blob([JSON.stringify(data, null, 2)], {
        type: 'application/json',
      });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();

      // Объектный URL держит файл в памяти вкладки, пока его не отпустят.
      URL.revokeObjectURL(url);
    },
  };
}
